/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { JIRA_INTEGRATION_ORGANIZATION_UUID } from '~feature-jira/helpers';
import { OrganizationJiraBinding } from '~feature-jira/index';
import { useAvailableFeatures } from '~sq-server-commons/context/available-features/withAvailableFeatures';
import { Feature } from '~sq-server-commons/types/features';

export function InstanceJiraBinding() {
  const { hasFeature } = useAvailableFeatures();
  const hasJiraIntegrationFeature = hasFeature(Feature.JiraIntegration);

  return (
    hasJiraIntegrationFeature && (
      <OrganizationJiraBinding
        isCustomJiraApp
        isFormDiscreet
        organizationKey="sonarqube-server"
        organizationUuid={JIRA_INTEGRATION_ORGANIZATION_UUID}
        withProjectPermissionsSwitch
      />
    )
  );
}
